<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="onClose"><span class="blind">X</span></button>
      <h2 class="layerTitle">{{locale.page_set_available}}</h2>
      <div :data-state="availableState">
        <div class="availableState mb15">
          <span class="checkbox radio">
            <input type="radio" name="available_time_state" id="available_time_state_always" value="01" v-model="availableState">
            <label for="available_time_state_always">{{locale.page_available_always}}</label>
          </span>
          <span class="checkbox radio">
            <input type="radio" name="available_time_state" id="available_time_state_each" value="02" v-model="availableState">
            <label for="available_time_state_each">{{locale.page_available_each}}</label>
          </span>
        </div>
        <ul class="dayTable">
          <li v-for="day in availableTable"
            :key="day.id"
            class="dayItem"
            :class="{dayOff: !day.available}">
            <div class="day checkbox">
              <input type="checkbox" name="available" :id="`available_${day.id}`" :val="day.id" v-model="day.available">
              <label :for="`available_${day.id}`">{{locale[day.id]}}</label>
            </div>
            <div class="timeList">
              <div v-for="(time, index) in day.time"
                :key="index"
                @click="editTime(day.id, index, time)"
                class="time">
                {{time.from}} - {{time.to}}
                <button type="button" class="btnDel" @click="delTime($event, day.id, index)"></button>
              </div>
            </div>
            <div class="add">
              <button type="button" class="btn btnPrimary sizeS" @click="editTime(day.id)">{{locale.add}}</button>
            </div>
          </li>
        </ul>
      </div>
      <div class="btns">
        <button type="button" class="btn btnFull btnPrimary" @click="apply">{{locale.apply}}</button>
      </div>
    </div>
    <AvailableTimeEdit
      v-if="timeEditLayer"
      :locale="locale"
      :timeInfo="editTimeInfo.time"
      @apply="applyTime"
      @close="timeEditLayer = false" />
  </div>
</template>

<script>
import AvailableTimeEdit from '@/components/Util/AvailableTimeEdit'

export default {
  name: 'AvailableTime',
  props: [
    'locale',
    'available'
  ],
  components: {
    AvailableTimeEdit
  },
  computed: {
  },
  created () {
    function getOvertime (time) {
      const timeFrom = parseInt(time.from.replace(':', ''))
      const timeTo = parseInt(time.to.replace(':', ''))
      const isOvertime = timeFrom > timeTo
      return isOvertime
    }
    if (this.available && this.available.state) {
      this.availableState = this.available.state
    }
    if (this.available && this.available.set) {
      /**
       * 구 데이터 중 timeFrom, timeTo 객체를
       * 배열로 변환하여 다중시간 설정 할 수 있도록 변경
       */
      this.availableTable = this.available.set.map(x => {
        const time = x.time || (
          x.timeFrom && x.timeTo && 
            [
              {
                from: x.timeFrom,
                to: x.timeTo
              }
            ]
        )
        return {
          ...x,
          time: time
        }
      })
      /**
       * 구 데이터 중 익일로 넘어가는 시간대가 있었음(21:00 ~ 06:00)
       * 이 시간을 자정으로 쪼개어 다음날로 넘김
       */
      for (let i = 0; i < this.availableTable.length; i++) {
        const day = this.availableTable[i]
        const nextDay = i === this.availableTable.length - 1 ? this.availableTable[0] : this.availableTable[i + 1]
        const times = day.time
        for (let t = 0; t < times.length; t++) {
          const time = times[t]
          const timeTo = time.to
          if (getOvertime(time)) { // 익일로 넘어가면
            time.to = '24:00' // 오늘은 자정까지
            nextDay.time.unshift({ // 다음날은 자정부터 to까지
              from: '00:00',
              to: timeTo
            })
          }
        }
      }
    }
  },
  data () {
    return {
      availableState: '01',
      availableTable: [],
      timeEditLayer: false,
      editTimeInfo: {
        day: null,
        timeIndex: null,
        time: null
      }
    }
  },
  methods: {
    setTime () {
      let hour = []
      let minute = []
      // 시간은 00, 01, 02, ..., 24
      for (let i = 0; i <= 24; i++) {
        hour.push(`${('0' + i).slice(-2)}`)
      }
      // 분은 00, 10, 20, ..., 50 (10분단위)
      for (let i = 0; i <= 5; i++) {
        minute.push(`${('0' + i * 10).slice(-2)}`)
      }
      return {
        hour: hour,
        minute: minute
      }
    },
    getTime (time) {
      return {
        hh: time.split(':')[0],
        mm: time.split(':')[1]
      }
    },
    editTime (dayId, timeIndex, time) {
      this.timeEditLayer = true
      this.editTimeInfo = {
        day: dayId,
        timeIndex: timeIndex,
        time: time
      }
    },
    applyTime (time) {
      const add = this.editTimeInfo.timeIndex === null || this.editTimeInfo.timeIndex === undefined
      const timeIndex = this.editTimeInfo.timeIndex
      const dayId = this.editTimeInfo.day
      const day = this.availableTable.find(x => x.id === dayId)
      if (add) { // add
        day.time.push(time)
      } else { // modify
        day.time = day.time.map((x, i) => {
          return i !== timeIndex ? x : time
        })
      }
      day.available = day.time.length > 0
      this.timeEditLayer = false
      this.editTimeInfo = {
        day: null,
        timeIndex: null,
        time: null
      }
    },
    closeEditTime () {
      this.timeEditLayer = false
    },
    delTime (e, dayId, timeIndex) {
      e.stopPropagation()
      if (window.confirm(this.locale.confirm_delete)) {
        const day = this.availableTable.find(x => x.id === dayId)
        day.time = day.time.filter((x, i) => i !== timeIndex)
        day.available = day.time.length > 0
      }
    },
    onClose () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.$emit('close')
      }
    },
    apply () {
      if (window.confirm(this.locale.confirm_apply)) {
        this.$emit('apply', {
          state: this.availableState,
          set: this.availableTable
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
[data-state="01"] .dayTable {
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $color-white;
    opacity: 0.5;
    cursor: not-allowed;
    z-index: 1;
  }
}
.availableState {
  padding: 15px;
  border-radius: 10px;
  background-color: $color-white;
}
.dayItem {
  display: flex;
  padding: 5px;
  border-radius: 10px;
  background-color: $color-white;
  & + .dayItem {
    margin-top: 5px;
  }
  &.dayOff {
    opacity: 0.5;
  }
  .day {
    width: 80px;
    margin-right: 0;
    padding-top: 10px;
    padding-left: 15px;
  }
  .timeList {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    .time {
      position: relative;
      margin: 2px 4px;
      padding: 10px 15px;
      border-radius: 10px;
      background-color: rgba($color-lgrey2, 0.5);
      .btnDel {
        position: absolute;
        top: 0;
        right: 0;
        width: 20px;
        height: 20px;
        margin-top: -4px;
        margin-right: -4px;
        border-radius: 100%;
        background: $color-grey url('~@/assets/img/ico_close.svg') 50% 50% / 8px no-repeat;
      }
    }
  }
  .add {
    margin-left: auto;
    .btn {
      margin: 2px;
      padding: 10px 15px;
      border-radius: 10px;
    }
  }
}
.btns {
  width: 180px;
  margin: 30px auto 0;
}
</style>
